import { HttpClient } from 'src/clients';

class AssetService {
  static getAssetDetails(assetId) {
    return HttpClient.get(`/asset/${assetId}/details`);
  }
}

export { AssetService };
